import type { ReactElement } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "@/core/auth/auth-provider";
import { isActingAsActive } from "@/core/auth/admin-acting-session";
import { Alert, AlertDescription, AlertTitle, Button } from "@/shared/components/ui";

export function ActingAsBanner(): ReactElement | null {
  const auth = useAuth();
  const navigate = useNavigate();
  const actingSession = auth.session?.actingSession;

  if (!actingSession || !isActingAsActive(actingSession)) {
    return null;
  }

  const effectiveEmail = actingSession.effectiveUser.email;
  const actualEmail = actingSession.actualUser.email;
  const returnRoute = actingSession.returnRoute;

  async function returnToAdmin(): Promise<void> {
    await auth.stopActingAs();
    void navigate(returnRoute, { replace: true });
  }

  return (
    <Alert variant="warning" className="rounded-none border-x-0 border-t-0">
      <div className="clm-page-gutter flex flex-col gap-3 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <AlertTitle>Acting as {effectiveEmail}</AlertTitle>
          <AlertDescription>
            Actual admin: {actualEmail}. Effective-user roles drive member navigation until you
            return.
          </AlertDescription>
        </div>
        <Button type="button" variant="outline" onClick={() => void returnToAdmin()}>
          Back to admin
        </Button>
      </div>
    </Alert>
  );
}
